import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import Dropdown from './BankDropDown.js';

const IdealContainer = ({ items , onChange  })=>{
    const { getLabel  } = useIntl();
    const { isPaymentMethodsNewUIEnabled  } = useFeatureToggles();
    const labels = React.useMemo(()=>({
            title: getLabel('checkout.payment.method.ideal.select.title'),
            info: getLabel('checkout.payment.method.ideal.info')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Dropdown, {
        id: "idealBankSelect",
        name: "idealBankSelect",
        placeholder: labels.title,
        options: items,
        onChange: onChange,
        label: labels.title
    }), isPaymentMethodsNewUIEnabled && /*#__PURE__*/ React.createElement(Text, {
        className: "ideal-payment__info"
    }, labels.info));
};

export { IdealContainer };
//# sourceMappingURL=IdealContainer.js.map
